import Header from "../Component/Header";
import Footer from "../Component/Footer";
import Breadcrumb from "../Component/Breadcrumb";
const SchoolCabinet = () => {
  return (
    <>
      <Header />
      <Breadcrumb
        title="Student Cabinets"
        midBreadcrumb="Office Bearers"
        mainBreadcrumb="Student Cabinets"
      ></Breadcrumb>
      <div className="inner-page">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h2 class="mainhead mainhead-center">Student Cabinets</h2>
              <h3 class="subhead text-center">
                If your actions inspire others to dream more, learn more, do
                more and become more, you are a leader
              </h3>
            </div>
          </div>
          <div class="row sc">
            <div class="col-lg-6">
              <h2>Head Boy & Head Girl</h2>
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/HeadBoy.jpg"
                          class="img-fluid"
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">Head Boy</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">KOVID</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/HeadGirl.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">Head Girl</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">ANSHU</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <h2>Ass.Head Boy & Ass.Head Girl</h2>
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/Ass-HeadBoy.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">Ass. Head Boy</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">MONIK GOYAL</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/Ass-HeadGirl.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation"> Ass. Head Girl</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name"> ADITI</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <h2>Cultural Minister</h2>
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/CulturalMinister-1.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            Cultural & SOCIAL WELFARE Minister
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">ARUSH</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/CulturalMinister-2.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            Cultural & SOCIAL WELFARE Minister
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name"> NIKITA</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <h2>Sports Minister</h2>
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/SportsMinister-1.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">Sports Minister</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name"> MUSKAN</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/SportsMinister-2.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">Sports Minister</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">KANISHK</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <h2>Home Minister </h2>
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/HomeMinister-1.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">Home Minister </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">HIMANSHU</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/HomeMinister-2.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">Home Minister </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">KANISHKA</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <h2> EXternal Affairs Minister</h2>
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/EXternalAffairsMinister-1.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            EXternal Affairs Minister
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">JAYA</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/EXternalAffairsMinister-2.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            EXternal Affairs Minister
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">KRISHNA</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <h2> Student Interest Group Minister </h2>
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/InterestGroupMinister-1.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            {" "}
                            Student Interest Group Minister
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name"> GARV</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/InterestGroupMinister-2.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            {" "}
                            Student Interest Group Minister
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">MOKSHIKA</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            {/* <div class="col-lg-6">
              <h2>Language Minister</h2>
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/7. ENGLISH EDITOR SAKSHI XII (SCI.jpg"
                          class="img-fluid"
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            Language Minister
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">SAKSHI XII (SCI)</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/8. HINDI EDITOR MISHIKA IX(ROSE).JPG"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            Language Minister
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">MISHIKA IX(ROSE)</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          <div class="row sc">
            <div class="col-lg-6">
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/PRIME-MINISTER.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation"> PRIME MINISTER</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name"> ANUSHKA</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/DEPUTY-PRIME-MINISTER.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            {" "}
                            DEPUTY PRIME MINISTER
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">SARTHAK</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/GENERAL-SECRETARY.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            {" "}
                            GENERAL SECRETARY
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name"> MAYANK</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/DEPUTY-GENERAL-SECRETARY.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            {" "}
                            DEPUTY GENERAL SECRETARY
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">PALAK</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/SPEAKER.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation"> SPEAKER</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name"> UTKARSH </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/DEPUTY-SPEAKER.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation"> DEPUTY SPEAKER</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">KANIKA</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/ENGLISH-EDITOR.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation"> ENGLISH EDITOR</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name"> CHEHAK </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/HINDI-EDITOR.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation"> HINDI EDITOR</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">BHUVI </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row sc">
            <div class="col-lg-6">
              <h2 class="bg-red">Red House</h2>
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/Red-House-Captain.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            Red House Captain
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">CHAVI-Captain</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/Red-House-ViceCaptain.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            Red House Vice Captain
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">UNIT-Vice Captain</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <h2 class="bg-blu">Blue House</h2>
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/Blue-House-Captain.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">Blue House</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">NITIN-Captain</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/Blue-House-ViceCaptain.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            Blue House Vice Captain
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">NOYA-Vice Captain</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <h2 class="bg-yellow">Yellow House</h2>
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/Yellow-House-Captain.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">Yellow House</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">KRISHNA-Captain</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/Yellow-House-ViceCaptain.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            Yellow House Vice Captain
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">DIVYA-Vice Captain</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <h2 class="bg-green">Green House</h2>
              <div class="row g-3">
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/GreenHouseCaptain.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">
                            Green House Captain
                          </div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">YAJAT-Captain</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div class="col-sm-6 col-6">
                  <div class="student-cabinets">
                    <figure>
                      <div class="cabinet-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/GreenHouseViceCaptain.jpg"
                          class="img-fluid "
                          alt="matamariamjansevavidyalayas"
                        />
                        <div class="cabinet-detail">
                          <div class="cabinet-designation">Green House</div>
                        </div>
                      </div>
                      <figcaption class="text-center">
                        <div class="cabinet-name">DIVYA-Vice Captain</div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default SchoolCabinet;
